import {BaseDialogViewModel} from "../common/BaseDialogViewModel";
import {BadRequestError} from "../../../tracejs/src/application/BadRequestError";
import {Tracedo} from "../../entities/Tracedo";
import {Checkpoint} from "../../entities/Checkpoint";
import {i18n} from "i18next-ko";
import moment from "moment/moment";
import {h} from "../../../tracejs/src/utils/JSXFactory";
import {injectable} from "tsyringe";

@injectable()
export class TrainDepartureDialog extends BaseDialogViewModel<any> {

    private atd: KnockoutObservable<Date>;
    private etd: KnockoutObservable<Date>;

    async startup(): Promise<any> {
        await super.startup();

        if (!this.user.isAllowed('entity.tracedo', 'approve')) {
            throw new BadRequestError('Access denied', 403);
        }

        let tracedo: Tracedo = await this.rpc.call('tracedo.getOne', { id: this.settings.tracedoId, query: { select: "id, railLoadId, checkpoints(*, ramp(*))" } });
        if (!tracedo.railLoadId) {
            throw new BadRequestError('Not Found', 404);
        }

        let railLoadCheckpoint: Checkpoint = tracedo.checkpoints.filter((checkpoint: Checkpoint): boolean => checkpoint.id == tracedo.railLoadId)[0];
        this.atd = ko.observable(railLoadCheckpoint.atd ? kendo.parseDate(railLoadCheckpoint.atd as string) : null);
        this.etd = ko.observable(railLoadCheckpoint.etd ? kendo.parseDate(railLoadCheckpoint.etd as string) : null);
    }

    public async save(): Promise<boolean> {
        const atd = this.atd()
        const etd = this.etd()
        const atdString = atd === null ? null : moment(atd).format();
        const etdString = etd === null ? null : moment(etd).format();

        await this.rpc.call('tracedo.setTrainDeparture', { id: this.settings.tracedoId, atd: atdString, etd: etdString });
        return true;
    }

    public dialogTemplate = (): HTMLElement => (
        <div>
            <div className="row mb-2">
                <label className="inline col-md-2 col-form-label"
                       data-bind="uniqueFor: 'trainDepartureEtd', i18n: 'common.captions.etd'"></label>
                <div className="col-md-10">
                    <input type="text" className="form-control"
                           data-bind="kendoDateTimePicker: { value: etd, animation: false }, uniqueId: 'trainDepartureEtd'"/>
                </div>
            </div>
            <div className="row mb-2">
                <label className="inline col-md-2 col-form-label"
                       data-bind="uniqueFor: 'trainDepartureAtd', i18n: 'common.captions.atd'"></label>
                <div className="col-md-10">
                    <input type="text" className="form-control"
                           data-bind="kendoDateTimePicker: { value: atd, animation: false }, uniqueId: 'trainDepartureAtd'"/>
                </div>
            </div>
        </div>
    )
}